import { v4 as uuidv4 } from "uuid";

export function getOrCreateUserId() {
  let uid = localStorage.getItem("_campaign_uid");
  if (!uid) {
    uid = uuidv4();
    localStorage.setItem("_campaign_uid", uid);
  }
  return uid;
}
